import React from 'react'

/**
 * Klarer Fortschrittsbalken im ChatGPT-Stil: ein Balken, dezenter Track, solide Füllung.
 * Kein Gradient, keine Shimmer-Animation – nur saubere Breite.
 */
export default function ProgressBar({
  progress = 0,
  variant = 'default', // 'default' | 'success' | 'error'
  showLabel = false,
  live = false,
  className = '',
  barClassName = '',
}) {
  const pct = Math.min(100, Math.max(0, Number(progress)))
  const fillColors = {
    default: 'bg-[#00d4aa]',
    success: 'bg-emerald-500',
    error: 'bg-red-500',
  }
  const fillClass = fillColors[variant] || fillColors.default
  return (
    <div className={className}>
      {showLabel && (
        <div className="mb-1 flex justify-between text-sm text-white/70">
          <span>Fortschritt</span>
          <span>{Math.round(pct)}%</span>
        </div>
      )}
      <div
        className="h-2 w-full overflow-hidden rounded-full bg-white/15"
        role="progressbar"
        aria-valuenow={pct}
        aria-valuemin={0}
        aria-valuemax={100}
      >
        <div
          className={`h-full rounded-full transition-all duration-500 ease-out ${fillClass} ${barClassName}`}
          style={{ width: `${pct}%` }}
        />
      </div>
    </div>
  )
}
